'use strict';

import merchants from '@/assets/js/api/functions';

export default {
    namespaced: true,
    state: {
        merchant: {}
    },
    getters: {
        getMerchant: (state) => state.merchant
    },
    mutations: {
        SET_MERCHANT(state, value) {
            state.merchant = value;
        },
        CLEAR_STATE(state) {
            state.merchant = {};
        }
    },
    actions: {
        findMerchant(context, payload) {
            console.log(payload);
            let { id, config } = payload || {};
            return new Promise((resolve, reject) => {
                merchants
                    .getData({ to: `/external/merchants/${id}`, config })
                    .then((response) => {
                        // console.log(response);
                        context.commit('SET_MERCHANT', response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        // console.log(error);
                        context.commit('SET_MERCHANT', {});
                        // context.dispatch('error', error, { root: true });
                        reject(error);
                    });
            });
        },
        findMerchantByMobile(context, payload) {
            console.log(payload);
            let { mobile, config } = payload || {};
            return new Promise((resolve, reject) => {
                merchants
                    .getData({ to: `/external/merchants/by-mobile/${mobile}`, config })
                    .then((response) => {
                        // console.log(response);
                        context.commit('SET_MERCHANT', response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        // console.log(error);
                        context.commit('SET_MERCHANT', {});
                        // context.dispatch('error', error, { root: true });
                        reject(error);
                    });
            });
        }
    }
};
